/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CatalogCreateCatalogRequest } from "../models/CatalogCreateCatalogRequest";
import type { CatalogCreateCatalogResponseApiRespoonse } from "../models/CatalogCreateCatalogResponseApiRespoonse";
import type { CatalogDeleteCatalogRequest } from "../models/CatalogDeleteCatalogRequest";
import type { CatalogDeleteCatalogResponseApiRespoonse } from "../models/CatalogDeleteCatalogResponseApiRespoonse";
import type { CatalogListCatalogsRequest } from "../models/CatalogListCatalogsRequest";
import type { CatalogListCatalogsResponseApiRespoonse } from "../models/CatalogListCatalogsResponseApiRespoonse";
import type { CatalogShowCatalogRequest } from "../models/CatalogShowCatalogRequest";
import type { CatalogShowCatalogResponseApiRespoonse } from "../models/CatalogShowCatalogResponseApiRespoonse";
import type { CatalogUpdateCatalogRequest } from "../models/CatalogUpdateCatalogRequest";
import type { CatalogUpdateCatalogResponseApiRespoonse } from "../models/CatalogUpdateCatalogResponseApiRespoonse";

import type { CancelablePromise } from "../core/CancelablePromise";
import { OpenAPI } from "../core/OpenAPI";
import { request as __request } from "../core/request";

export class CatalogsManagerService {
  /**
   * Get list catalogs
   * @param requestBody
   * @returns CatalogListCatalogsResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static catalogs(
    requestBody: CatalogListCatalogsRequest
  ): CancelablePromise<CatalogListCatalogsResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/catalogs",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Create catalog
   * @param requestBody
   * @returns CatalogCreateCatalogResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static catalogsCreate(
    requestBody: CatalogCreateCatalogRequest
  ): CancelablePromise<CatalogCreateCatalogResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/catalogs/create",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Update catalog
   * @param requestBody
   * @returns CatalogUpdateCatalogResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static catalogsUpdate(
    requestBody: CatalogUpdateCatalogRequest
  ): CancelablePromise<CatalogUpdateCatalogResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/catalogs/update",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Get show catalog
   * @param requestBody
   * @returns CatalogShowCatalogResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static catalogsShow(
    requestBody: CatalogShowCatalogRequest
  ): CancelablePromise<CatalogShowCatalogResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/catalogs/show",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }

  /**
   * Delete catalog
   * @param requestBody
   * @returns CatalogDeleteCatalogResponseApiRespoonse 正常レスポンス
   * @throws ApiError
   */
  public static catalogsDelete(
    requestBody: CatalogDeleteCatalogRequest
  ): CancelablePromise<CatalogDeleteCatalogResponseApiRespoonse> {
    return __request(OpenAPI, {
      method: "POST",
      url: "/api/catalogs/delete",
      body: requestBody,
      mediaType: "applicatin/json",
      errors: {
        400: `Fail to process.`,
        401: `fail to authentication`,
        419: `token mismatch`,
      },
    });
  }
}
